"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableauError = void 0;
/**
 * Custom error class that extends the default JavaScript Error object.
 * This allows us to provide a field with a specific error code
 * so that developers can more easily programmatically respond
 * to error scenarios.
 */
class TableauError extends Error {
    constructor(_errorCode, message) {
        super(`${_errorCode}: ${message}`);
        this._errorCode = _errorCode;
        /*tslint:disable-next-line */
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        // Error inheritance does not work propertly when compiling to ES5, this is a workaround to force
        // the proto chain to be built correctly.  See the github link above for details.
        Object.setPrototypeOf(this, TableauError.prototype);
    }
    get errorCode() {
        return this._errorCode;
    }
}
exports.TableauError = TableauError;
//# sourceMappingURL=TableauError.js.map